'use strict';

// Init the application configuration module for AngularJS application
var ApplicationConfiguration = (function () {
	// Init module configuration options
	var applicationModuleName = 'controlPanelApp';

	var applicationModuleVendorDependencies = [
		'ngAnimate',
		'ngResource',
		'jcs-autoValidate',
		'ngStorage',
		'ui.router',
		'ngTouch',
		'summernote',
		'ui.bootstrap',
		'angular-loading-bar',
		'colorpicker.module',
		'videosharing-embed',
		'flow',
		'ui.utils.masks',
		'uiCropper',
		'cp.ngConfirm',
		'angular-ladda',
		'ngTagsInput',
		'idf.br-filters',
		'ngRateIt',
		'chart.js',
		'pascalprecht.translate',
		'ngFileSaver',
		'ui.bootstrap',
		'checklist-model'
	]

	// Add a new vertical module
	var registerModule = function (moduleName, dependencies) {
		// Create angular module
		angular.module(moduleName, dependencies || []);

		// Add the module to the AngularJS configuration file
		angular.module(applicationModuleName).requires.push(moduleName);
	};

	return {
		applicationModuleName: applicationModuleName,
		applicationModuleVendorDependencies: applicationModuleVendorDependencies,
		registerModule: registerModule
	};
})();